import React, { useRef, useState, useEffect } from 'react';
import BracketBox from '../../extra/BracketBox';

const SpotCompare = ({ value, value1, date }) => {
  const imageRef = useRef(null);
  const containRef = useRef(null);
  return (
    <div
      ref={containRef}
      style={{
        position: 'relative',
        display: 'inline-block',
        margin: '10px'
      }}
    >
      <img
        key={value}
        src={value}
        // alt="Zoom"
        ref={imageRef}
        style={{
          display: 'block',
          width: '100%',
          borderRadius: 4
        }}
        onError={(e) => e.target.style.display = "none"}

      />

      <BracketBox
        key={value1}
        noZoom
        containRef={containRef}
        imageRef={imageRef}
        color="#fbe324"
        lensSize={400}
        extraSrc={value1}
        lensVisible={true}
        info={date}
        infoBoxWidth={150}

      />
    </div>
  );
};

export default SpotCompare;
